import type { Station } from "@station/domain/models/station.model";
import type { SpatialLevelRepository } from "@station/domain/repositories/spatial-level.repository.ts";
import { stationsTypes } from "@station/station-types.di.ts";
import { inject, injectable } from "inversify";

@injectable()
export class SpatialLevelRefreshStationUseCase {
    constructor(
        @inject(stationsTypes.repositories.SpatialLevelRepository)
        private readonly spatialLevelRepository: SpatialLevelRepository,
    ) {}

    execute(station: Readonly<Station>): void {
        this.spatialLevelRepository.refreshStation(station);
    }
}
